export const getLoginRequiredResolveObj = () => ({
  loginRequired: ['AuthService', (AuthService: any) => AuthService.loginRequired()],
});
